<div class="header">
  <div class="container">
    <a href="javascript:void(0);" class="logo"><img src="../assets/img/vivotek-logo-w.svg" alt="" /></a>
    <h1 class="title"><span *ngIf="!license">Trial VCA</span><span *ngIf="license=='free'">Smart VCA</span> License Application</h1>
  </div>
</div>
<div class="container-wrap">
  <div class="container">
    <div class="alert alert-warning alert-dismissible fade" [ngClass]="{ show: hasError }" role="alert">
      {{ errorMessage }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row">
      <div class="col" *ngIf="!license">
        <div class="card card-csv">
          <div class="card-header">
            Single License
          </div>

          <div class="card-body">
            <!-- (ngSubmit)="submitSingle()" -->
            <form [formGroup]="frmSingleLicense">
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label">Email</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="email_single"
                    [ngClass]="{ 'is-invalid': frmSingle.email.errors }" placeholder="Email" formControlName="email" maxlength="200" />
                  <div *ngIf="frmSingle['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['email'].errors.required">
                      Email is required
                    </div>
                  </div>
                  <div *ngIf="frmSingle['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['email'].errors.email">
                      Email format invalid
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="modelName" class="col-md-4 col-form-label">Model Name</label>
                <div class="col-md-8">
                  <!-- <input
                    type="text"
                    class="form-control"
                    id="modelName"
                    [ngClass]="{ 'is-invalid': frmSingle.modelName.errors }"
                    placeholder="Model Name"
                    formControlName="modelName"
                  /> -->
                  <ng-select [items]="modelNameTypes" bindLabel="text" bindValue="id" formControlName="modelName"
                    [clearable]="false" [ngClass]="{ 'is-invalid': frmSingle.modelName.errors }">
                  </ng-select>
                  <div *ngIf="frmSingle['modelName'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['modelName'].errors.required">
                      Model Name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="macAddress" class="col-md-4 col-form-label">Mac Address</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="macAddress"
                    [ngClass]="{ 'is-invalid': frmSingle.macAddress.errors }" placeholder="Mac Address"
                    formControlName="macAddress" style="text-transform: uppercase;" />
                  <div *ngIf="frmSingle['macAddress'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['macAddress'].errors.required">
                      MAC Address is required
                    </div>
                    <div *ngIf="frmSingle['macAddress'].errors.pattern">
                      The pattern of MAC Address is not valid
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="licenseType" class="col-md-4 col-form-label">License Type</label>
                <div class="col-md-8">
                  <ng-select [items]="licenseTypes" bindLabel="text" bindValue="codeId" formControlName="licenseType"
                    [searchable]="false" [clearable]="false" [ngClass]="{ 'is-invalid': frmSingle.licenseType.errors }">
                  </ng-select>
                  <div *ngIf="frmSingle['licenseType'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['licenseType'].errors.required">
                      License Type is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-4 col-form-label">Expiration Date</label>
                <div class="col-md-8 col-form-label">
                  <label>{{ frmSingle.expireDate.value }}</label>
                  <!-- <ng-select [items]="filterExpireDateTypes" bindLabel="text" bindValue="id"
                    formControlName="expireDate" [searchable]="false" [clearable]="false"
                    [ngClass]="{ 'is-invalid': frmSingle.expireDate.errors }">
                  </ng-select> -->
                  <!-- <input type="text" class="form-control" id="expireDate"
                    [ngClass]="{ 'is-invalid': frmSingle.expireDate.errors }" placeholder="Expire Date"
                    formControlName="expireDate" /> -->
                </div>
              </div>
              <button [disabled]="!frmSingleLicense.valid" type="submit" class="btn btn-primary btn-csv w-100"
                [swal]="confirmSwal" (click)="handleConfirm('single')">
                Generate
              </button>
            </form>
          </div>
        </div>
      </div>
      <div class="col" *ngIf="license=='free'">
        <div class="card card-csv">
          <div class="card-header">
            Single License
          </div>
          <div class="card-body">
            <!-- (ngSubmit)="submitSingle()" -->
            <form [formGroup]="frmSingleLicense">
              <div class="form-group row">
                <label for="company" class="col-md-4 col-form-label">Company Name</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="company_free"
                    [ngClass]="{ 'is-invalid': frmSingle.company.errors }" placeholder="Company Name" formControlName="company" maxlength="50"/>
                  <div *ngIf="frmSingle['company'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['company'].errors.required">
                      Company Name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="contact" class="col-md-4 col-form-label">Contact Person</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="contact_free"
                    [ngClass]="{ 'is-invalid': frmSingle.contact.errors }" placeholder="Contact Person" formControlName="contact" maxlength="50"/>
                  <div *ngIf="frmSingle['contact'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['contact'].errors.required">
                      Contact Person is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="contact" class="col-md-4 col-form-label">Contact Persion Phone Number</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="contact_free"
                    [ngClass]="{ 'is-invalid': frmSingle.contactPersionPhone.errors }" placeholder="Contact Persion Phone Number" formControlName="contactPersionPhone" maxlength="50"/>
                  <div *ngIf="frmSingle['contactPersionPhone'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['contactPersionPhone'].errors.required">
                      Contact Persion Phone Number is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label">Email</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="email_single"
                    [ngClass]="{ 'is-invalid': frmSingle.email.errors }" placeholder="Email" formControlName="email" />
                  <div *ngIf="frmSingle['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['email'].errors.required">
                      Email is required
                    </div>
                  </div>
                  <div *ngIf="frmSingle['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['email'].errors.email">
                      Email format invalid
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="country" class="col-md-4 col-form-label">Country</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="country_single"
                    [ngClass]="{ 'is-invalid': frmSingle.country.errors }" placeholder="Country" formControlName="country" />
                  <div *ngIf="frmSingle['country'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['country'].errors.required">
                      Country is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="applicationType" class="col-md-4 col-form-label">Application Type</label>
                <div class="col-md-8">
                  <ng-select [items]="applicationTypes" bindLabel="text" bindValue="codeId" formControlName="applicationType"
                    [clearable]="false" [ngClass]="{ 'is-invalid': frmSingle.applicationType.errors }">
                  </ng-select>
                  <div *ngIf="frmSingle['applicationType'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['applicationType'].errors.required">
                      Application Types is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="modelName" class="col-md-4 col-form-label">Model Name</label>
                <div class="col-md-8">
                  <!-- <input
                    type="text"
                    class="form-control"
                    id="modelName"
                    [ngClass]="{ 'is-invalid': frmSingle.modelName.errors }"
                    placeholder="Model Name"
                    formControlName="modelName"
                  /> -->
                  <ng-select [items]="modelNameTypes" bindLabel="text" bindValue="id" formControlName="modelName"
                    [clearable]="false" [ngClass]="{ 'is-invalid': frmSingle.modelName.errors }">
                  </ng-select>
                  <div *ngIf="frmSingle['modelName'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['modelName'].errors.required">
                      Model Name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="macAddress" class="col-md-4 col-form-label">Mac Address</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="macAddress"
                    [ngClass]="{ 'is-invalid': frmSingle.macAddress.errors }" placeholder="Mac Address"
                    formControlName="macAddress" style="text-transform: uppercase;" />
                  <div *ngIf="frmSingle['macAddress'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['macAddress'].errors.required">
                      MAC Address is required
                    </div>
                    <div *ngIf="frmSingle['macAddress'].errors.pattern">
                      The pattern of MAC Address is not valid
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="licenseType" class="col-md-4 col-form-label">License Type</label>
                <div class="col-md-8">
                  <ng-select [items]="licenseTypes" bindLabel="text" bindValue="codeId" formControlName="licenseType"
                    [searchable]="false" [clearable]="false" [ngClass]="{ 'is-invalid': frmSingle.licenseType.errors }">
                  </ng-select>
                  <div *ngIf="frmSingle['licenseType'].errors" class="invalid-feedback">
                    <div *ngIf="frmSingle['licenseType'].errors.required">
                      License Type is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row" >
                <label class="col-md-4 col-form-label">Expiration Date</label>
                <div class="col-md-8 col-form-label">
                  <label>{{ frmSingle.expireDate.value }}</label>
                  <!-- <ng-select [items]="filterExpireDateTypes" bindLabel="text" bindValue="id"
                    formControlName="expireDate" [searchable]="false" [clearable]="false"
                    [ngClass]="{ 'is-invalid': frmSingle.expireDate.errors }">
                  </ng-select> -->
                  <!-- <input type="text" class="form-control" id="expireDate"
                    [ngClass]="{ 'is-invalid': frmSingle.expireDate.errors }" placeholder="Expire Date"
                    formControlName="expireDate" /> -->
                </div>
              </div>
              <button  [disabled]="!frmSingleLicense.valid" type="submit" class="btn btn-primary btn-csv w-100"
                [swal]="confirmSwal" (click)="handleConfirm('single')">
                Generate
              </button>
            </form>
          </div>
        </div>
      </div>
      <!-- (ngSubmit)="uploadFile()" -->
      <!-- <div class="col-lg-6 mt-lg-0 mt-5">
        <div class="card card-csv">
          <div class="card-header">
            Multi License
          </div>
          <div class="card-body">
            <form [formGroup]="frmMultiLicense">
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label">Email</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" id="email_multiple"
                    [ngClass]="{ 'is-invalid': frmMulti.email.errors }" placeholder="Email" formControlName="email" />
                  <div *ngIf="frmMulti['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['email'].errors.required">
                      Email is required
                    </div>
                  </div>
                  <div *ngIf="frmMulti['email'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['email'].errors.email">
                      Email format invalid
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="csvFile" class="col-md-4 col-form-label">Excel File</label>
                <div class="col-md-8">
                  <input #licenseFileElem formControlName="licenseFile"
                    [ngClass]="{ 'is-invalid': frmMulti.licenseFile.errors }" type="file" (change)="fileChanged($event)"
                    class="form-control-file" accept=".xlsx" />
                  <div *ngIf="frmMulti['licenseFile'].errors" class="invalid-feedback">
                    <div *ngIf="frmMulti['licenseFile'].errors.required">
                      File is required
                    </div>
                  </div>
                </div>
              </div>
              <a [href]="baseUrl + '/Generate/Download'" class="mb-4 d-inline-block link-csv" target="_blank">Sample
                Excel</a>
              <button [disabled]="!frmMultiLicense.valid" type="submit" class="btn btn-primary btn-csv w-100"
                [swal]="confirmSwal" (click)="handleConfirm('multi')">
                Generate
              </button>
            </form>
          </div>
        </div>
      </div> -->
    </div>
    <div class="mt-5 text-center">
      <p>
        If you have any question, please contact
        <a *ngIf="!license" href="mailto: emma.hsiavivotek.com">emma.hsia@vivotek.com</a>
        <a *ngIf="license=='free'" href="mailto: emma.hsia@vivotek.com">emma.hsia@vivotek.com</a>
      </p>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
<swal #confirmSwal title="Captcha" [showConfirmButton]="false" [showCloseButton]="true" [showCancelButton]="true"
  (beforeOpen)="beforeOpen($event)">
  <form *swalPartial [formGroup]="frmCaptcha" (ngSubmit)="submit()">
    <div class="form-group row mt-3">
      <div class="col-md-2">
        <a href="javascript:void(0);" (click)="beforeOpen()">
          <img *ngIf="captcha?.image" class="img" [src]="captcha?.image" />
        </a>
      </div>
      <div class="col-md-6">
        <input class="form-control" formControlName="image" />
      </div>
      <div class="col-md-4">
        <button class="btn btn-primary" type="submit" [disabled]="!frmCaptcha?.valid">
          Submit
        </button>
      </div>
    </div>
  </form>
</swal>
